import { render, staticRenderFns } from "./SeriesSearch.vue?vue&type=template&id=61fae47e&"
import script from "./SeriesSearch.vue?vue&type=script&lang=js&"
export * from "./SeriesSearch.vue?vue&type=script&lang=js&"
import style0 from "./SeriesSearch.vue?vue&type=style&index=0&id=61fae47e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports